import { ActionError, PromisifiedActionMeta } from 'Interfaces/ActionCreators';
import { NormalizedEntity } from 'Interfaces/Common';
import { Contract, ContractsPayload } from 'Interfaces/Contract';
import { createAsyncAction } from 'typesafe-actions';
import { promisifyAsyncAction } from 'Utils/functions';

import { DocumentGetFormRequestContractsActionTypes } from './actionTypes';

export const getFormRequestContracts = createAsyncAction(
  DocumentGetFormRequestContractsActionTypes.request,
  DocumentGetFormRequestContractsActionTypes.success,
  DocumentGetFormRequestContractsActionTypes.failure,
  DocumentGetFormRequestContractsActionTypes.cancel,
)<
  [ContractsPayload, PromisifiedActionMeta],
  [NormalizedEntity<Contract>, PromisifiedActionMeta],
  [ActionError, PromisifiedActionMeta],
  [undefined, PromisifiedActionMeta]
>();
export const $getFormRequestContracts = promisifyAsyncAction(getFormRequestContracts);
